import { useEffect } from 'react';
import { useAppSelector } from '../Store';
import { useAuthStore } from '../Store/Slices/AuthSlice';
import { identifyProduktlyUser } from '../Utils/ProduktlyIntegration';

/**
 * Custom hook to identify the user to Produktly whenever authentication state changes
 * 
 * @returns {boolean} - Whether the user is authenticated
 */
const useProduktlyUser = (): boolean => {
  const { data, userConfig } = useAppSelector(useAuthStore);
  const isAuthenticated = userConfig !== null;

  useEffect(() => {
    // Only identify user if they are authenticated and we have user data
    if (isAuthenticated && data?.data?.user) {
      // Use the user ID as the unique identifier for Produktly
      const userId = data.data.user.id;
      
      // Pass the user data to identify the user in Produktly
      identifyProduktlyUser(userId, data.data);
    }
  }, [isAuthenticated, data]);

  return isAuthenticated;
};

export default useProduktlyUser; 